import { render } from "./ProspectDetailModal.vue?vue&type=template&id=fb8fdf22&scoped=true"
import script from "./ProspectDetailModal.vue?vue&type=script&lang=js"
export * from "./ProspectDetailModal.vue?vue&type=script&lang=js"

import "./ProspectDetailModal.vue?vue&type=style&index=0&id=fb8fdf22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8fdf22"]])

export default __exports__